import React, { useState, useEffect } from "react";
import useSound from "use-sound";
import { GameContainer, GameWrapper } from "../../AppStyled";

import Header from "./header/Header";
import Main from "./mines/Main";
import SubText from "./subText/SubText";
import Footer from "./footer/Footer";
import AutoSelect from "../otherPages/autoRoll/AutoSelect";

import OtherPages from "../otherPages/OtherPages";

import useGlobalAudio from "../shared/audio/globalAudio";
import backgroundSFX from "../../assets/audio/globals/backgroundSFX.mp3";
import useLoading from "../loading/useLoading";
import Loading from "../loading/Loading";

export default ({
  balance,
  bet,
  userInfo,
  userId,
  bombs,
  provablyFair,
  autorollLogic,
  history,
  above,
  aboveAnim,
  aboveSetting,
  aboveSettingAnim,
  isAutoOn,
  isClickable,
  notifyText,
  autoConfigs,
  selectedSpheres,
  stateRound,
  Globals,
  handleAbove,
  handleAboveAnim,
  handleSetting,
  handleNotification,
  handleBetAmount,
  handleAutoRollLogic,
  handleResult,
  result,
  perfectWin,
  explosion,
  handleStop,
  handleSelectedSpheres,
  saveBet,
  saveMines,
  handleBombs,
  isManual,
  manualPlay,
  userSelected,
  handleGameStep,
  handleRandomGameStep,
  handleCashout,
  handleStartRound,
  handleAutoRoll,
  handleAutoSelect,
  autoSelect,
  gamePlayAnimation,
  autoAnim,
  userSettings,
  saveUserSettings,
  autoBets,
  isDisabled,
  toggleIsDisabled,
  floorFigure,
  dynamicSoundChange,
  getBetReply,
  betReply,
  handleVolumeLocal,
  volumeLocal,
  gameStates,
  newDisable,
}) => {
  const ballsq = (q) => {
    let b = [];
    for (let i = 0; i <= q; i++) {
      b.push(i.toString());
    }
    return b;
  };

  const { board, currentCoef, state } = stateRound;

  const [autoBoardBalls, setAutoBoardBalls] = useState(false);
  const [balls, setBalls] = useState([]);
  const [cashout, setCashout] = useState(null);
  const [leftSpheres, setLeftSpheres] = useState(null);
  const [leftSpheresAuto, setLeftSpheresAuto] = useState(null);
  const { AUDIO } = useGlobalAudio(userSettings.volume, userSettings.sound);
  useEffect(() => {
    let yellows = board.filter(function (value) {
      return value === "0";
    }).length;
    if (!result && !board.includes("3")) {
      setLeftSpheres(yellows - bombs);
    } else if (board.includes("3")) {
      setLeftSpheres(0);
    } else {
      setLeftSpheres(25 - bombs);
    }
  }, [bombs, board, result]);

  useEffect(() => {
    setLeftSpheresAuto(25 - bombs);
  }, [bombs, userSelected]);

  useEffect(() => {
    setBalls(ballsq(24));
  }, []);

  useEffect(() => {
    let cash = parseFloat(bet) * currentCoef;
    if (parseFloat(bet) === cash) {
      setCashout(cash.toFixed(userInfo.precision));
    } else {
      setCashout(floorFigure(cash, userInfo.precision));
    }
  }, [bet, currentCoef, userInfo.precision, floorFigure]);

  /* <<<<<< background music >>>>>> */

  // set music is on/off for looping background music
  const [musicIsOn, setMusicIsOn] = useState(false);

  const [play, { stop }] = useSound(backgroundSFX, {
    volume: volumeLocal,
    onend: () => setMusicIsOn(true),
  });

  const enableLoading = false
  const [isLoaded, setisLoaded] = useState(false)
  const pages = [
    "settings",
    "gameRules",
    "provFair",
    "history",
    "selectMines",
    "autoConfig"
  ]
  const loadedPages = enableLoading ? [] : pages

  const [arePagesLoaded, duration] = useLoading(handleAbove, loadedPages)
  useEffect(() => {
    setisLoaded(arePagesLoaded)
  }, [arePagesLoaded, userId, setisLoaded])


  // stop music before initialize, if error occures or if music is off
  useEffect(() => {
    if ((userSettings.music === "1" || musicIsOn) && isLoaded) {
      stop();
      play();
      setMusicIsOn(false);
    } else {
      stop();
    }
    return function cleanup() {
      stop();
    };
  }, [play, stop, userSettings.music, musicIsOn, isLoaded]);
  return (
    <>
     {isLoaded ? <div> <GameContainer className="GamePlay">
        <GameWrapper
          blur={(aboveAnim && above) || (aboveSetting && aboveAnim)}
          isClickable={{ isClickable, isManual }}
        >
          <Header
            handleSetting={handleSetting}
            handleAboveAnim={handleAboveAnim}
            balance={balance}
            floorFigure={floorFigure}
            userInfo={userInfo}
            audio={AUDIO.goForward}
          />
          {autoSelect ? (
            <AutoSelect
              handleAutoSelect={handleAutoSelect}
              handleAbove={handleAbove}
              handleSelectedSpheres={handleSelectedSpheres}
              selectedSpheres={selectedSpheres}
              handleAutoRoll={handleAutoRoll}
              handleNotification={handleNotification}
              balls={balls}
              leftSpheres={leftSpheresAuto}
              handleAboveAnim={handleAboveAnim}
              isDisabled={isDisabled}
              toggleIsDisabled={toggleIsDisabled}
              autoBoardBalls={() => (e) => setAutoBoardBalls(e)}
              userSettings={userSettings}
              audio={AUDIO}
            />
          ) : (
            <>
              <Main
                balls={balls}
                board={board}
                isAutoOn={isAutoOn}
                manualPlay={manualPlay}
                selectedSpheres={selectedSpheres}
                handleGameStep={handleGameStep}
                userSelected={userSelected}
                result={result}
                handleNotification={handleNotification}
                autoAnim={autoAnim}
                perfectWin={perfectWin}
                explosion={explosion}
                autoBoardBalls={autoBoardBalls}
                dynamicSoundChange={dynamicSoundChange}
                userSettings={userSettings}
                stateRound={stateRound}
              />
              <SubText
                handleAbove={handleAbove}
                userSelected={userSelected}
                bombs={bombs}
                stateRound={stateRound}
                bet={bet}
                manualPlay={manualPlay}
                // autoPlay={autoPlay}
                isAutoOn={isAutoOn}
                result={result}
                leftSpheres={leftSpheres}
                floorFigure={floorFigure}
                handleNotification={handleNotification}
                handleBetAmount={handleBetAmount}
                handleAboveAnim={handleAboveAnim}
                autoAnim={autoAnim}
                userInfo={userInfo}
                userSettings={userSettings}
                audio={AUDIO.goForward}
                newDisable={newDisable}
              />
              <Footer
                balance={balance}
                bet={bet}
                userInfo={userInfo}
                state={state}
                autoAnim={autoAnim}
                userSelected={userSelected}
                isAutoOn={isAutoOn}
                manualPlay={manualPlay}
                cashout={cashout}
                handleAbove={handleAbove}
                handleAboveAnim={handleAboveAnim}
                handleBetAmount={handleBetAmount}
                handleNotification={handleNotification}
                handleStartRound={handleStartRound}
                handleRandomGameStep={handleRandomGameStep}
                handleCashout={handleCashout}
                handleStop={handleStop}
                floorFigure={floorFigure}
                handleResult={handleResult}
                result={result}
                gamePlayAnimation={gamePlayAnimation}
                autoBets={autoBets}
                betCount={autorollLogic.numBets}
                betTotal={autoConfigs.numberOfBets}
                toggleIsDisabled={toggleIsDisabled}
                userSettings={userSettings}
                isDisabled={isDisabled}
                audio={AUDIO}
                gameStates={gameStates}
                newDisable={newDisable}
              />
            </>
          )}
        </GameWrapper>
      </GameContainer>
      <OtherPages
        bet={bet}
        userInfo={userInfo}
        bombs={bombs}
        provablyFair={provablyFair}
        history={history}
        notifyText={notifyText}
        autoConfigs={autoConfigs}
        Globals={Globals}
        above={above}
        aboveAnim={aboveAnim}
        aboveSetting={aboveSetting}
        handleAbove={handleAbove}
        handleAboveAnim={handleAboveAnim}
        handleSetting={handleSetting}
        handleNotification={handleNotification}
        handleBombs={handleBombs}
        handleBetAmount={handleBetAmount}
        handleAutoSelect={handleAutoSelect}
        handleAutoRollLogic={handleAutoRollLogic}
        saveMines={saveMines}
        saveBet={saveBet}
        isClickable={isClickable}
        isAutoOn={isAutoOn}
        floorFigure={floorFigure}
        aboveSettingAnim={aboveSettingAnim}
        saveUserSettings={saveUserSettings}
        userSettings={userSettings}
        userId={userId}
        getBetReply={getBetReply}
        betReply={betReply}
        handleVolumeLocal={handleVolumeLocal}
        explosion={explosion}
        audio={AUDIO}
      /></div> : <Loading duration={duration} />}
    </>
  );
};
